<template>
    <div class="example">
        <m-card title="时间线">
            <!-- <timeline></timeline> -->
        </m-card>

        <m-card title="图片上单张">
            <upload v-model="imgs1" :default="defaultImgs1" />
        </m-card>

        <m-card title="图片上传多张">
            <upload :limit="10" v-model="imgs" :default="defaultImgs" :extensions="extensions" />
        </m-card>

        <m-card title="视频上传1">
            <upload v-model="video" :default="video" type="video" :limit="1" needFileInfo />
        </m-card>

        <m-card title="热区编辑">
            <m-hotArea @getHotCode="getHotCode" @getMedia="getMedia" :itemData="imgData"></m-hotArea>
            <!-- <m-hotArea @getHotCode="getHotCode"  :defaultImg="[defaultImgs1]" ></m-hotArea> -->
        </m-card>

    </div>
</template>

<script>
import timeline from "components/timeline";
import transfer from "components/transfer";
import upload from "components/upload";
// import hotArea from "components/hotArea/hotArea";

export default {
    name: "example",
    components: { timeline, transfer, upload },
    data() {
        return {
            imgData: {
                hotareaList: [
                    {
                        x: 114,
                        y: 45,
                        width: 150,
                        height: 150,
                        link: "https://m.meb.com",
                        alt: "美呗",
                        checked: true,
                        coordinate: "114,45,264,195",
                        coordinateApp: "86,31,198,135",
                    },
                ],
                viewPc: "",
                viewApp: "",
                media: {
                    imgUrl: "https://cdn-workorder.meb.com/2020/02/12/1229233162",
                    videoUrl: "",
                },
            },
            hotAreas: {},
            imgs: [],
            video: [],
            defaultImgs: [],
            imgs1: "",
            defaultImgs1: "https://cdn-workorder.meb.com/2020/02/12/1229233162",
            extensions: [
                {
                    isActive: false,
                    icon: "el-icon-star-off",
                    activeIcon: "el-icon-star-on",
                    style: "",
                    activeStyle: "",
                    click(img) {
                        this.isActive = !this.isActive;
                    },
                },
            ],
        };
    },
    methods: {
        getHotCode(data) {
            this.hotAreas = data;
        },
        getMedia(type, url) {
            if (type == "img") this.imgData.media.imgUrl = url;
            else {
                this.imgData.media.videoUrl = url;
                this.imgData.media.videoCover =
                    url + "?vframe/jpg/offset/1/w/148";
            }
        },
    },
    watch: {
        video(value) {},
    },
    created() {
        setTimeout(() => {
            this.defaultImgs = [
                "https://cdn-workorder.meb.com/2020/02/12/1229233162",
                "https://cdn-workorder.meb.com/2020/02/12/1229233162",
            ];
        }, 2000);
    },
};
</script>

<style lang="less" scoped>
</style>
